import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum DeviceType {
  HANDSET = 1, //Phone
  MOBILE = 2, //Phone + Tablet + small Desktop
  DESKTOP = 3
}

@Injectable()
export class DeviceService {


  private deviceType = DeviceType.DESKTOP;
  private deviceSubject = new BehaviorSubject<DeviceType>(DeviceType.DESKTOP);

  constructor(private platform: Platform, private breakpointObserver: BreakpointObserver) {}

  public init(): void {
    this.deviceType =
      this.platform.ANDROID === true || this.platform.IOS === true ? DeviceType.MOBILE : DeviceType.DESKTOP;
    this.updateDeviceSubject();
    if (this.deviceType === DeviceType.MOBILE) {
      // according to Material Design spec https://material.io/design/layout/responsive-layout-grid.html#breakpoints
      this.breakpointObserver.observe([
          Breakpoints.HandsetLandscape,
          Breakpoints.HandsetPortrait
        ])
        .subscribe(result => {
          if (result.matches) {
            this.deviceType = DeviceType.HANDSET;
          } else {
            this.deviceType = this.breakpointObserver.isMatched('(min-width: 1280px)') ? DeviceType.DESKTOP : DeviceType.MOBILE;
          }
          this.updateDeviceSubject();
        });
    } else {
      this.breakpointObserver.observe(['(max-width: 967px)']) // 839 (standard) + 128 (Sidebar-width/2)
        .subscribe(result => {
          this.deviceType = result.matches ? DeviceType.MOBILE : DeviceType.DESKTOP;
          this.updateDeviceSubject();
        });
    }
  }

  public isSafariBrowser(): boolean {
    return this.platform.SAFARI;
  }

  public isHandset(): boolean {
    return this.deviceType === DeviceType.HANDSET;
  }

  public isDesktop(): boolean {
    return this.deviceType === DeviceType.DESKTOP;
  }

  public isMobile(): boolean {
    return this.deviceType === DeviceType.MOBILE || this.deviceType === DeviceType.HANDSET;
  }

  public isTypeMobileOrHandset(type: DeviceType) {
    return type === DeviceType.HANDSET || type === DeviceType.MOBILE;
  }

  /**
   * Verwendet bei onPush Changedetection wenn z.B. im html auf Veränderung der Deviceclasses reagiert werden muss
   */
  public getDeviceSubject(): BehaviorSubject<DeviceType> {
    return this.deviceSubject;
  }

  public generateDeviceClass(): string {
    if (this.isMobile()) {
      if (this.isHandset()) {
        return 'phone';
      } else {
        return 'mobile';
      }
    } else {
      return 'desktop';
    }
  }

  public generateDeviceClassPrimaryDevices(): string {
    if (this.isMobile()) {
      return 'mobile';
    } else {
      return 'desktop';
    }
  }

  private updateDeviceSubject(): void {
    this.deviceSubject.next(this.deviceType);
  }

}
